export const useFimProduct = (key = 'useFimProduct') => {
  const { data, fetch, fetching } = useFimRpc('getProductById', key)

  return {
    data,
    fetch,
    fetching,
  }
}
